import { createRouter, createWebHistory } from 'vue-router'

import adminRoutes from './admin.js'
import customerRoutes, { defaultMeta } from './customer.js'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: 90,
      }
    }

    return { top: 0 }
  },
  routes: [
    adminRoutes,
    customerRoutes,
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login/Index.vue')
    }
  ]
})

router.beforeEach((to) => {
  let descriptionElement = document.querySelector('head meta[name="description"]')

  const { title, description } = to.meta
    ? { ...defaultMeta, ...to.meta }
    : defaultMeta

  if (!descriptionElement) {
    descriptionElement = document.createElement('meta')
    descriptionElement.setAttribute('name', 'description')
    document.head.appendChild(descriptionElement)
  }

  document.title = title
  descriptionElement.setAttribute('content', description)
})

export default router
